"use client";

import React from "react";

//Types
import { ContainerFullProps } from "@/types";

//Styles
import * as S from "./styles";

const ContainerFull: React.FC<ContainerFullProps> = ({
  className,
  children,
}) => {
  return <S.Container className={className}>{children}</S.Container>;
};

export default ContainerFull;
